<template>
  <div v-if="trip_data.length > 0">
    <b-modal id="jet2-trip-info-modal" ref="jet2-trip-info-modal-ref" hide-footer :title="trip_data[0].name">
      <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ababab"
        img-width="1024" img-height="480" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd">
        <!-- Text slides with image -->
        <div v-for="(image, index) in trip_data[0].imagelinks" :key="`images_header - ${index}`">
          <b-carousel-slide :img-src="image"></b-carousel-slide>
        </div>
      </b-carousel>
      <div>
        <h4 class="mt-3 orange">Resort</h4>
        <p class="text-left" v-html="trip_data[0].resort"></p>
      </div>
      <div v-if="trip_data[0].rating">
        <h4 class="mt-3 orange">Rating</h4>
        <p class="text-left">{{ trip_data[0].rating }} <i class="material-icons vtd-ml-3">star</i></p>
      </div>
      <div v-if="trip_data[0].locationandresort">
        <h4 class="mt-3 orange">Location Information</h4>
        <p class="text-left" v-html="trip_data[0].locationandresort"></p>
      </div>
      <div v-if="trip_data[0].description">
        <h4 class="mt-3 orange">Description</h4>
        <p class="text-left" v-html="trip_data[0].description"></p>
      </div>
      <div v-if="trip_data[0].eatinganddrinking">
        <h4 class="mt-3 orange">Eating and Drinking</h4>
        <p class="text-left" v-html="trip_data[0].eatinganddrinking"></p>
      </div>
      <div v-if="trip_data[0].swimmingpools">
        <h4 class="mt-3 orange">Swimming Pools</h4>
        <p class="text-left" v-html="trip_data[0].swimmingpools"></p>
      </div>
      <div v-if="trip_data[0].activitiesandentertainment">
        <h4 class="mt-3 orange">Activities and Entertainment</h4>
        <p class="text-left" v-html="trip_data[0].activitiesandentertainment"></p>
      </div>
      <div v-if="trip_data[0].transfertime">
        <h4 class="mt-3 orange">Transfer Time</h4>
        <p class="text-left" v-html="trip_data[0].transfertime"></p>
      </div>
    </b-modal>
    <button class="btn-info" @click="$refs['jet2-trip-info-modal-ref'].show()">
      <i class="material-icons vtd-icon-2 vtd-mr-3">info</i><span>Property Details</span>
    </button>
  </div>
</template>
<script>
import { fetchJet2Info } from "../../modules/booking/itinerary/items/accommodation/services";

export default {
  props: {
    item: null,
  },
  data() {
    return {
      trip_data: {},
      slide: 0,
      sliding: null,
    };
  },
  async mounted() {
    let tmp = this.item.addresslines[0];
    if(this.item.addresslines[0].indexOf(',') > -1) {
      tmp = this.item.addresslines[0].split(',')[0];
    }
    this.trip_data = await fetchJet2Info(tmp);
  },
  methods: {
    show() {
      this.$refs["jet2-trip-info-modal-ref"].show();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
  height: 30rem;
  overflow: hidden;
}

.modal-banner-text {
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.itinerary-container {
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.inclusion-container {
  background-color: #dbdbdb;
  margin: 10px;
  padding: 10px;
}

.address {
  text-indent: 40px;
}

.image-size {
  height: 55vh;
}

.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.vtd-font-weight-bold {
  font-weight: bolder;
}

.orange {
  color: orange;
  font-weight: bolder;
}
</style>